export default __webpack_public_path__ + "static/media/right.931b7e89.svg";